<template>
    <li
        class="select-none px-8 py-4 group transition"
        :class="this.$parent.$parent.answer === this.selection ? 'bg-red' : 'hover:bg-grey-lightest '"
        @click="update"
    >
        <div class="transition group-hover:translate-x-2">
            <div
                class="relative mt-1 font-bold text-xl leading-none transition"
                :class="
                    this.$parent.$parent.answer === this.selection
                        ? 'text-white'
                        : 'text-grey-darkest group-hover:text-pink'
                "
            >
                {{ name }}
            </div>
        </div>
    </li>
</template>

<script>
export default {
    props: ['name', 'selection'],
    methods: {
        update() {
            if (this.$parent.processing === false) {
                this.$parent.selectedTitle = this.name
                this.$parent.$parent.answer = this.selection
                this.$parent.closeDoor()
            }
        },
    },
}
</script>
